import React from "react";
import "./Sections.scss";

function QA7() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          How do you ensure your vision comes through while telling such a
          famous story?
        </p>
        <p className="interview__interview__copy">
          I never copy what exists—I always make, from a concept, another
          concept. In my imagination I changed the end of the Romeo and Juliet
          story. In my imagination there is a happy wedding at the end.
        </p>
        <p className="interview__interview__copy">
          And so, we created the Love in Verona collection. The bracelet came
          first, but now the collection has grown to include an engagement ring
          and a wedding set. After all, creativity is endless.
        </p>
      </div>
    </section>
  );
}

export default QA7;
